import { Component, OnInit, ViewChild, ViewChildren, ChangeDetectionStrategy, ChangeDetectorRef, QueryList, ViewContainerRef } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { LyDialog } from '@alyle/ui/dialog';
import { ImgCropperEvent } from '@alyle/ui/image-cropper';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { AuthService } from 'app/auth/auth.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { CloudService } from 'app/main/pagina/tools/cloud/cloud.service';
import { EditorEncuestaService } from "./editor-encuesta.service";

import {TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_editorEncuesta } from 'app/idiomas/i18n/editor-encuesta/editor-encuesta.lang';

import { DATOS_API } from 'app/auth/auth.datos';
import paginas from "./catalogo-elementos";
import { ModalImgComponent } from "./modal-img/modal-img.component";
import { ModalEditorComponent } from "./modal-editor/modal-editor.component";

const moment = require('moment');

@Component({
  selector: 'app-editor-encuesta',
  templateUrl: './editor-encuesta.component.html',
  styleUrls: ['./editor-encuesta.component.scss'],
  animations   : fuseAnimations
})
export class EditorEncuestaComponent implements OnInit {

  // @ViewChild('editorMce',{static:false}) editorMce: any;
  // @ViewChildren('editorMce',{ read: ViewContainerRef }) editorMce: QueryList<ViewContainerRef>;

  opciones = {
    menubar: false,
    plugins: 'print preview paste importcss searchreplace autolink save directionality code visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    toolbar: 'undo redo | bold italic underline strikethrough | fontsizeselect | table | \
              alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | \
              forecolor backcolor removeformat | charmap emoticons | fullscreen  preview | \
              link codesample | ltr rtl',
    toolbar_sticky: true,
    height: 250,
    toolbar_mode: 'sliding',
    // language: 'en_US'
  };

  faseCarga = 0;
  cargando = true;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  idiomas: any = [];
  idiomaNative: any;

  // paginas = paginas;
  paginas: any;

  // cropped?: string;
  cropped?: any = {};

  jsonsConfiguracion: any = {};
  jsonsConfiguracionOrig: any = {};
  jsonsModificacion: any = {};
  jsonsModificacionOrig: any = {};

  datasets: FormGroup[] = [];
  datasetsModif: FormGroup[] = [];
  formValido: boolean;

  urlSurvey = 'https://newsurvey.culturalgo.com/appsurvey/assets/images/';
  idEmpresa: string;
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";
  camposImagen = ["logo","backgroudImage","backgroundImage"]; //nombres de campos que contienen imagenes

  editorCargado = false;
  guardandoTemplate = false;

  carpetaImagenes: any;
  versionCloudNueva: boolean;
  fechaNuevaVersion = "2021-10-04";   //este dia se adaptó la carga de imagenes al fileserver

  constructor(
    private location: Location,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private _dialog: LyDialog,
    private _cd: ChangeDetectorRef,
    private edEncSrv: EditorEncuestaService,
    private wizardService: WizardService,
    private authService: AuthService,
    private cloudService: CloudService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
  ) {
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_editorEncuesta.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.wizardService.getInfoEmpresa().subscribe((data:any) => {
      console.log("infoEmpresa:",data);
      // this.direccionRaiz = this.direccionRaiz + data.data.nombreEmpresa + "/";
      let infoUsu: any = this.authService.getInfoUsuario();
      this.idEmpresa = infoUsu.empresaId;

      if(moment(data.createdAt).isAfter(moment(this.fechaNuevaVersion)) ){  //si la fecha es posterior a la indicada, nueva version
        this.versionCloudNueva = true;
        this.nuevo_gotoRaiz();
      } else{   //version anterior
        this.direccionRaiz = this.direccionRaiz + localStorage.getItem('companyID') + "/";
        // this.getRaiz();
      }
    });
    this.paginas = paginas;
    setTimeout(() => {
      this.editorCargado = true;
      let esperaImg = setInterval(function () {
        if($(".tox-notifications-container").length && $(".tox-statusbar__branding")){
          $(".tox-notifications-container").hide();
          $(".tox-statusbar__branding").hide();
          clearInterval(esperaImg);
        }
      }, 0);
    }, 3000);
    this.obtieneIdiomasGuardados();
  }

  //// SERVICIOS FILE SERVER
  nuevo_gotoRaiz(){
    this.cloudService.getArchivos_nuevo("").subscribe((respuesta:any) => {
      console.log("getArchivos_nuevo raiz:",respuesta);
      if(respuesta.success){
        this.nuevo_getCarpeta(null, null, true);
      } else{
        this.nuevo_creaCarpetaRaiz();
      }
    });
  }
  nuevo_creaCarpetaRaiz(nombreCarpeta?:string){
    const datos = {
      empresaId: localStorage.getItem('companyID'),
      folderId: nombreCarpeta == undefined ? null : this.carpetaImagenes._id,
      path: nombreCarpeta == undefined ? localStorage.getItem('companyID') : this.carpetaImagenes.path + '/' + nombreCarpeta,
      itbm: nombreCarpeta == undefined ? true : false
    };
    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      console.log("creaCarpeta_nuevo:",respuesta);
      this.nuevo_gotoRaiz();
      // this.nuevo_getCarpeta(this.carpetaImagenes);
    })
  }
  nuevo_getCarpeta(datosFolder?:any, subcarpetas?:boolean, raiz?: boolean){
    let folderId: string = null;
    if(datosFolder){
      this.carpetaImagenes = datosFolder;
      folderId = datosFolder._id;
    }
    this.cloudService.getCarpetas_nuevo(folderId).subscribe((respuesta_2:any) => {
      if(respuesta_2.success){
        /// PRIMER PASO, OBTENCION DE DATOS DE LA CARPETA
        if(!subcarpetas){
          if(raiz){
            this.carpetaImagenes = respuesta_2.folders[0];
          }
          console.log("datosCarpetaActual:",this.carpetaImagenes);
          //hacer el get de nuevo para obtener las subcarpetas
          this.nuevo_getCarpeta(this.carpetaImagenes, true);
        } else{ /// SEGUNDO PASO, OBTENCION DE LISTA DE SUBCARPETAS Y ARCHIVOS
          const listaSubcarpetasActual: any = respuesta_2.folders;
          console.log("subcarpetas de la actual:",listaSubcarpetasActual);

          // BUSCA LA CARPETA QUE TENGA EN LA UBICACION EL ID DE LA EMPRESA
          const datosCarpetaImgs = listaSubcarpetasActual.find(item => item.path.includes('editorImages'));
          console.log("datosCarpetaImgs:",datosCarpetaImgs);

          if(datosCarpetaImgs != undefined){
            this.carpetaImagenes = datosCarpetaImgs;
          } else{
            this.nuevo_creaCarpetaRaiz('editorImages');
          }
        }
      }
    });
  }

  obtieneIdiomasGuardados(){
    this.edEncSrv.getIdiomasProd().subscribe( (data: any) => {
      data.idiomasMostrar.forEach(idioma => {
        if(idioma.tipoIdioma != '3'){
          this.idiomas.push(idioma);
        }
      });
      console.log("idiomas:",this.idiomas);
      let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
      this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
      this.buscaElementosImagen();
      this.getJsons();
    });
  }

  getJsons(){
    this.edEncSrv.getJsons().subscribe((respuesta:any) => {
      // console.log("getJsons:",respuesta);
      if(respuesta.success){
        respuesta.surveyJsons.forEach(json => {
          if(!this.jsonsConfiguracion[json.lang]){
            // this.jsonsConfiguracion[json.lang] = [json];
            this.jsonsConfiguracion[json.lang] = {};
            this.jsonsConfiguracion[json.lang][json.type] = json;
          }
          else{
            // this.jsonsConfiguracion[json.lang].push(json);
            if(!this.jsonsConfiguracion[json.lang][json.type]){
              this.jsonsConfiguracion[json.lang][json.type] = json;
            }
          }
        });
        console.log("jsonsConfig:",this.jsonsConfiguracion);
        this.jsonsConfiguracionOrig = JSON.parse(JSON.stringify(this.jsonsConfiguracion));

        //crea los formgrups y asigna valores recuperados
        this.creaFormGroups(1);
      }
    });
    //////// JSONS DE MODIFICACIONES REALIZADAS
    this.edEncSrv.getJsonsConfig().subscribe((respuesta:any) => {
      // console.log("getJsonsConfig:",respuesta);
      if(respuesta.success){
        respuesta.surveyJsonsConfig.forEach(json => {
          if(!this.jsonsModificacion[json.lang]){
            this.jsonsModificacion[json.lang] = {};
            this.jsonsModificacion[json.lang][json.type] = json;
          }
          else{
            if(!this.jsonsModificacion[json.lang][json.type]){
              this.jsonsModificacion[json.lang][json.type] = json;
            }
          }
        });
        console.log("jsonsModificacion:",this.jsonsModificacion);
        this.jsonsModificacionOrig = JSON.parse(JSON.stringify(this.jsonsModificacion));

        //crea los formgrups y asigna valores recuperados
        this.creaFormGroups(2);
      }
    });
  }

  buscaElementosImagen(){
    this.idiomas.forEach(idioma => {
      this.paginas.forEach((pagina, i) => {
        pagina.pasos.forEach((paso, j) => {
          paso.elementos.forEach((elemento, k) => {
            if(elemento.tipo == 'imagen'){
              if(!this.cropped[`${idioma.nombreIdioma}_${pagina.id}_${paso.id}_${elemento.id}`]){
                this.cropped[`${idioma.nombreIdioma}_${pagina.id}_${paso.id}_${elemento.id}`] = '';
              }
            }
          });
        });
      });
    });
    console.log("cropped:",this.cropped);

  }

  cambioIdioma(event:any){
    console.log("event:",event);
    this.buscaModificacionesPasos(this.idiomas[event.index].nombreIdioma);
  }

  buscaModificacionesPasos(idioma:string){
    let claveArmada: string;
    this.paginas.forEach((pagina, i) => {
      pagina.pasos.forEach((paso, j) => {
        let status: boolean = false;
        let sumaElementos = 0;
        paso.elementos.forEach((elemento, k) => {
          claveArmada = `${idioma}_${pagina.id}_${paso.id}_${elemento.id}`;
          let BreakException = {};
          try {
            this.datasetsModif.forEach(dataset => {
              if(dataset.controls[claveArmada]){
                if(dataset.controls[claveArmada].value == true){
                  sumaElementos++;
                }
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          };
        });
        if(sumaElementos == paso.elementos.length){
          paso.status = 2;
        } else{
          if(sumaElementos > 0){
            paso.status = 1;
          } else{
            paso.status = 0;
          }
        }
        // console.log("sumaElementos:",sumaElementos);
        // console.log("status:",paso.status);
      });
    });
    console.log("cropped:",this.cropped);

  }

  creaFormGroups(origen:number){
    let referenciaDataSet: any;
    switch (origen) {
      case 1: referenciaDataSet = this.datasets; break; // json datos
      case 2: referenciaDataSet = this.datasetsModif; break; // json modificaciones
    }
    let dataSetActual = 0;
    let group = {};
    this.paginas.forEach(pagina => {
      if(dataSetActual != pagina.pagina){
        if(dataSetActual > 0){
          // this.datasets.push(new FormGroup(group) );
          referenciaDataSet.push(new FormGroup(group) );
        }
        dataSetActual = pagina.pagina;
        group = {};
      }

      pagina.pasos.forEach(paso => {
        paso.elementos.forEach(elemento => {
          this.idiomas.forEach(idioma => {
            group[`${idioma.nombreIdioma}_${pagina.id}_${paso.id}_${elemento.id}`] = new FormControl('', Validators.required);
          });
        });
      });
    });

    //inserta el ultimo formgroup
    // this.datasets.push(new FormGroup(group) );
    referenciaDataSet.push(new FormGroup(group) );
    // console.log("formgroups:",this.datasets);
    this.colocaValores(origen);

    this.datasets.forEach((dataset,i) => {
      dataset.valueChanges.subscribe( (res) => {
        // console.log("dataset",i,":",dataset.status);

        if(dataset.status == 'VALID'){
          this.formValido = this.formValido && true;
        }
        else{
          this.formValido = this.formValido && false;
        }
      });
    });
  }

  colocaValores(origen:number){
    let referenciaDataSet: any;
    let referenciaJsons: any;
    switch (origen) {
      case 1: referenciaDataSet = this.datasets; referenciaJsons = this.jsonsConfiguracion; break; // json datos
      case 2: referenciaDataSet = this.datasetsModif; referenciaJsons = this.jsonsModificacion; break; // json modificaciones
    }
    // this.datasets.forEach((dataset,idxPag) => {
    referenciaDataSet.forEach((dataset,idxPag) => {
      for(let control in dataset.controls){
        let camino = control.split("_");
        if(camino[1] != "1"){
          camino[1] = "2";
        }
        // this.navegaJsonRecursivo(idxPag,control,this.jsonsConfiguracion,camino,0,null,true);
        this.navegaJsonRecursivo(origen,idxPag,control,referenciaJsons,camino,0,null,true);
      }
    });
    // console.log("formgroups:",this.datasets);
    console.log(`formgroups ${origen}:`,referenciaDataSet);

    this.faseCarga++;
    if(this.faseCarga == 2){
      this.buscaModificacionesPasos(this.idiomaNative);
      this.cargando = false;
    }
  }

  cambiarImagen(idxPag:number, idxPaso:number, idxElm:number, idioma:string) {
    $(`#imagen${idioma}-${idxPag}-${idxPaso}-${idxElm}`).click();
  }

  arreglaUrlImgDef(ruta:string){
    let rutaAbsoluta = this.urlSurvey;
    if(!ruta.includes("http")){
      let rutaSplit = ruta.split("/");
      if(ruta.includes("assets")){
        let assetsFnd = false;
        let imagesFnd = false;
        rutaSplit.forEach((frag,i) => {
          if(assetsFnd && imagesFnd){
            rutaAbsoluta = rutaAbsoluta + frag;
            i < (rutaSplit.length - 1) ? rutaAbsoluta = rutaAbsoluta + "/" : false;
          }
          if(frag == "assets"){
            assetsFnd = true;
          }
          if(frag == "images"){
            imagesFnd = true;
          }
        });
      }
      else{
        rutaSplit.forEach((frag,i) => {
          rutaAbsoluta = rutaAbsoluta + frag;
          i < (rutaSplit.length - 1) ? rutaAbsoluta = rutaAbsoluta + "/" : false;
        });
      }
    }
    else rutaAbsoluta = ruta;
    return rutaAbsoluta;
  }

  openCropperDialog(event: Event, idxPag:number, pagina:string, paso:string, elemento:string, idioma:string) {
    // this.cropped = null!;
    this._dialog.open<ModalImgComponent, Event>(ModalImgComponent, {
      data: event,
      width: '100%',
      disableClose: true
    // }).afterClosed.subscribe((result?: ImgCropperEvent, objDrop?: any) => {
    }).afterClosed.subscribe((result?: any) => {
      let [resultado,objDrop] = result;
      if (resultado) {
        // this.cropped[`${pagina}_${paso}_${elemento}`] = resultado.dataURL;
        this._cd.markForCheck();
        console.log("resultado:",resultado);
        console.log("objDrop:",objDrop);

        fetch(resultado.dataURL)
          .then(res => res.blob()) // Gets the response and returns it as a blob
          .then(blob => {
            // Here's where you get access to the blob
            // And you can use it for whatever you want
            // Like calling ref().put(blob)

            // Here, I use it to make an image appear on the page
            // let objectURL = URL.createObjectURL(blob);
            // let myImage = new Image();
            // myImage.src = objectURL;
            // document.getElementById('myImg').appendChild(myImage)
            console.log("blob:",blob);
            let nombreRandom = Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000;
            // let file = new File([blob], objDrop.name, {type: objDrop.type});
            let file = new File([blob], nombreRandom.toString(), {type: objDrop.type});
            console.log("file:",file);
            if(this.versionCloudNueva){
              this.guardaImagenCargada_cloudNuevo(file, idxPag, pagina, paso, elemento, idioma);
            } else{   //version anterior
              this.guardaImagenCargada_cloudAnterior(file, idxPag, pagina, paso, elemento, idioma);
            }

        });
      }
    });
  }

  guardaImagenCargada_cloudAnterior(archivo:any, idxPag:number, pagina:string, paso:string, elemento:string, idioma:string){
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('file',archivo, archivo.name);
    fd.append('ubicacion',this.direccionRaiz);
    fd.append('empresaId',this.idEmpresa);
    // console.log(...fd);
    this.cloudService.guardaArchivo(fd).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAOK',1);
          // this.emitEventToChild();
          // this.guardandoArchivo = false;
          // this.progresoCarga = 0;
          let url = DATOS_API.urlLogos.split(":");
          let htp = DATOS_API.urlLogos.split("/");
          let urlFileManager = DATOS_API.urlFileManager;
          let urlImagenCargada = htp[0] + url[1] + urlFileManager + res.archivo.ubicacion.substr(2) + res.archivo.nombre;
          this.cropped[`${idioma}_${pagina}_${paso}_${elemento}`] = urlImagenCargada;
          this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].setValue(urlImagenCargada);
          this.modificarDatoJson(idxPag, pagina, paso, elemento, idioma);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
            // this.guardandoArchivo = false;
            // this.progresoCarga = 0;
          }
        }
      },
      (err) => console.log(err)
    );
  }
  guardaImagenCargada_cloudNuevo(archivo:any, idxPag:number, pagina:string, paso:string, elemento:string, idioma:string){
    let carpetaBroker = this.carpetaImagenes;
    let ubicacion = `${carpetaBroker.path}`;
    const reader: FileReader = new FileReader();
    let fd = new FormData();
    fd.append('File',archivo, archivo.name);
    fd.append('path',ubicacion);
    fd.append('mkdir','false');
    fd.append('copyifexists','false');
    fd.append('overwrite','false');
    // console.log(...fd);
    this.cloudService.guardaArchivo_nuevo(fd).subscribe((res) => {
        // console.log(res)
        if(res.status){
          if(res.status == "progress"){
            // this.progresoCarga = res.message;
          }
        }
        else if(res.success){
          console.log("cargaOk:",res);
          let urlFileServer = DATOS_API.endpoints.cloud.getArchivo;
          let urlImagenCargada = urlFileServer + ubicacion + '/' + res.response.Success;
          this.cropped[`${idioma}_${pagina}_${paso}_${elemento}`] = urlImagenCargada;
          this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].setValue(urlImagenCargada);
          this.modificarDatoJson(idxPag, pagina, paso, elemento, idioma);
        }
        else{
          if(res.message == 'archivo_save_1'){
            // this.mensajeSwal('FILEMANAGER.MENSAJES.CARGAREP',3);
            // this.guardandoArchivo = false;
            // this.progresoCarga = 0;
          }
        }
      },
      (err) => console.log(err)
    );
  }

  abreModalConfig(){
    const dialogRef = this.dialog.open(ModalEditorComponent, {
      width: '50%',
      disableClose: true,
      data: {
        opcion: 'configAdicional'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.via == 1){
      }
    });
  }

  abreModalEditor(idxPag:number, pagina:string, paso:string, elemento:string, idioma:string, tituloModal:string){
    let texto = this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].value;
    const dialogRef = this.dialog.open(ModalEditorComponent, {
      width: '70%',
      disableClose: true,
      data: {
        opcion: 'editar',
        texto,
        tituloModal
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.via == 1){
        if(result.texto != texto){
          console.log("son diferentes");
          this.datasets[idxPag].controls[`${idioma}_${pagina}_${paso}_${elemento}`].setValue(result.texto);
          this.modificarDatoJson(idxPag, pagina, paso, elemento, idioma);
        } else{
          console.log("son iguales");
        }
      }
    });
  }

  modificarDatoJson(idxPag:number, pagina:string, paso:string, elemento:string, idioma:string){
    console.log('Entro aqui ');

    // let clave = 'es_5_screens_2_customContent_reactive_workgroup_tooltip_text';
    let clave = `${idioma}_${pagina}_${paso}_${elemento}`;
    console.log('clave',clave);

    let camino = clave.split("_");
    if(camino[1] != "1"){
      camino[1] = "2";
    }
    this.navegaJsonRecursivo(1,idxPag,clave,this.jsonsConfiguracion,camino,0);  //aqui se actualiza el json de datos
  }

  navegaJsonRecursivo(origen:number, indicePagina:number, claveForm:string, datoActual:any, camino:any[], iter:number, esArreglo?:boolean, soloGet?:boolean){
    // console.log("entroRecu, indicePagina:",indicePagina,"claveForm:",claveForm,"datos:",datoActual,"camino:",camino,"iter:",iter,"arreglo?:",esArreglo);
    let referenciaDataSet: any;
    switch (origen) {
      case 1: referenciaDataSet = this.datasets; break; // json datos
      case 2: referenciaDataSet = this.datasetsModif; break; // json modificaciones
    }

    if(camino[iter] != undefined){

      if(iter < (camino.length - 1)){
        if(esArreglo){
          if(datoActual[parseInt(camino[iter])] != undefined){
            this.navegaJsonRecursivo(origen,indicePagina,claveForm,datoActual[parseInt(camino[iter])],camino,(iter + 1),Array.isArray(datoActual[parseInt(camino[iter])]),soloGet);
          }
        } else{
          if(datoActual.hasOwnProperty(camino[iter])){
            this.navegaJsonRecursivo(origen,indicePagina,claveForm,datoActual[camino[iter]],camino,(iter + 1),Array.isArray(datoActual[camino[iter]]),soloGet);
          }else{

          }
        }
      } else{
        if(datoActual.hasOwnProperty(camino[iter])){

          if(soloGet){
            // console.log("datoObtenido:",datoActual[camino[iter]]);
            if(this.camposImagen.includes(camino[iter])){
              // this.datasets[indicePagina].controls[claveForm].setValue(this.arreglaUrlImgDef(datoActual[camino[iter]]));
              if(origen == 1){  //json de datos
                referenciaDataSet[indicePagina].controls[claveForm].setValue(this.arreglaUrlImgDef(datoActual[camino[iter]]));
              } else{ // json de modificaciones
                referenciaDataSet[indicePagina].controls[claveForm].setValue(datoActual[camino[iter]]);
              }
            } else{
              // this.datasets[indicePagina].controls[claveForm].setValue(datoActual[camino[iter]]);
              referenciaDataSet[indicePagina].controls[claveForm].setValue(datoActual[camino[iter]]);
            }
          }
          else{

            if(origen == 1){
              // let datoModificado = this.datasets[indicePagina].controls[claveForm].value;
              let datoModificado = referenciaDataSet[indicePagina].controls[claveForm].value;
              // console.log("datoMod:-",datoModificado,"- datoJson:-",datoActual[camino[iter]],"-");
              if(datoModificado != datoActual[camino[iter]]){
                console.log("el dato es diferente");
                datoActual[camino[iter]] = datoModificado;
                this.actualizaJson(camino[0],camino[1],origen); //envía '1' o '2', depende que json se está modificando
                this.navegaJsonRecursivo(2,indicePagina,claveForm,this.jsonsModificacion,camino,0);  //aqui se actualiza el json de modificaciones
              } else{
                console.log("el dato es igual");
              }
            } else if(origen == 2){
              datoActual[camino[iter]] = true;
              referenciaDataSet[indicePagina].controls[claveForm].setValue(datoActual[camino[iter]]);
              this.actualizaJson(camino[0],camino[1],origen); //envía '1' o '2', depende que json se está modificando
              this.buscaModificacionesPasos(camino[0]);
            }
          }
        }else{

        }
      }
    }
  }

  actualizaJson(idioma:string, numJson:string, origen:number){
    let referenciaJsons: any;
    switch (origen) {
      case 1: referenciaJsons = this.jsonsConfiguracion; break; // json datos
      case 2: referenciaJsons = this.jsonsModificacion; break; // json modificaciones
    }
    // let datosJson = this.jsonsConfiguracion[idioma][numJson];
    let datosJson = referenciaJsons[idioma][numJson];
    let datosActualizar: any = {
      gptw: datosJson.gptw,
      generics: datosJson.generics
    };
    switch (numJson) {
      case '1': datosActualizar.screen = datosJson.screen; break;
      case '2': datosActualizar.screens = datosJson.screens; break;
    }
    console.log(`datosActualizar ${origen}:`,datosActualizar);
    if(origen == 1){  //si se actualiza el json de datos se activa el spinner
      this.guardandoTemplate = true;
      this.edEncSrv.update(datosJson._id, datosActualizar).subscribe((respuesta:any) => {
        console.log("updateJson:",respuesta);
        if(respuesta.success){
          this.guardandoTemplate = false;
        }
      });
    } else if(origen == 2){
      this.edEncSrv.updateConfig(datosJson._id, datosActualizar).subscribe((respuesta:any) => {
        console.log("updateJsonConfig:",respuesta);
        if(respuesta.success){
          this.guardandoTemplate = false;
        }
      });
    }

  }

  regresar(){
    this.location.back();
  }

  cambioEditor(e){
    console.log(e);
    // console.log("var Editor:",this.editorMce);
  }

  verAyudaElemento(pagina:number, paso:number){
    let tagImagen = `<img src="${DATOS_API.urlAssets}editorEncuesta/${(pagina + 1)}-${(paso + 1)}.png" alt="" width="100%">`;
    Swal.fire({
      title: this.translateSrv.instant('EDITOR.ELEMENTOS.GUIA'),
      // html: '<img src="https://www.harley-davidson.com/content/dam/h-d/images/product-images/bikes/motorcycle/2021/2021-sport-glide/2021-sport-glide-f16/2021-sport-glide-f16-motorcycle.jpg" alt="" width="100%">',
      html: tagImagen,

      confirmButtonText: 'OK',
      width: '80%'
    });
  }

}
